export default {
  auth: (state) => state.app.auth,
  footer: (state) => state.app.footer,
  header: (state) => state.app.header,
  homeActive: (state) => state.app.homeActive,
  home: (state) => state.app.home,
  token: (state) => state.app.token,
  isLogin: (state) => !!state.app.token,
  backgroundColor: (state) => state.app.backgroundColor,
  userInfo: (state) => state.app.userInfo || {},
  storeItems: (state) => state.app.storeItems || {},
  goName: (state) => state.app.goName,
  showWelcome: (state) => state.app.showWelcome,
};
